import ContentLoader from "@rio-cloud/rio-uikit/ContentLoader";

interface DetailFormSkeletonProps {
  rows?: number;
  splitRows?: number[];
  tallRows?: number[];
}

const LABEL_HEIGHT = 12;
const CONTROL_HEIGHT = 34;
const TALL_CONTROL_HEIGHT = 74;
const SPLIT_CONTROL_WIDTH = 170;
const LABEL_WIDTHS = [110, 85, 130, 95, 120, 75, 145, 100];

export default function DetailFormSkeleton({
  rows = 10,
  splitRows = [],
  tallRows = [],
}: Readonly<DetailFormSkeletonProps>) {
  const renderLabel = (index: number) => (
    <label className="margin-0 margin-bottom-5">
      <ContentLoader height={LABEL_HEIGHT} width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} />
    </label>
  );

  return (
    <div className="padding-x-20">
      {Array.from({ length: rows }, (_, index) =>
        splitRows.includes(index) ? (
          <div key={index} className="display-flex flex-wrap gap-15">
            {[0, 1].map((column) => (
              <div key={column} className="flex-1-1 form-group width-100pct-xs">
                {renderLabel(index + column)}
                <ContentLoader className="display-block" height={CONTROL_HEIGHT} width={SPLIT_CONTROL_WIDTH} />
              </div>
            ))}
          </div>
        ) : (
          <div key={index} className="form-group">
            {renderLabel(index)}
            <ContentLoader
              className="display-block"
              height={tallRows.includes(index) ? TALL_CONTROL_HEIGHT : CONTROL_HEIGHT}
              width="100%"
            />
          </div>
        )
      )}
    </div>
  );
}
